import _ from 'lodash';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { connect } from 'react-redux';
import * as IntercomActions from '../../redux/actions/intercom.actions';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import ExtensionRow from './ExtensionRow.jsx';

@connect(state => ({
  intercom: state.intercom,
  viewLoading: state.utils.viewLoading,
  themeName: state.settings.items.theme.data.themeName,
  routing: state.router,
}))
class ExtensionListView extends React.Component {
  
  appendExtensions(page) {
    const { dispatch } = this.props;
    dispatch(IntercomActions.appendExtensions(page));
  }

  render() {
    const { canCreateItem, intercom: { selectedExtension, extensions: { content: extensionData, pagination: { number: currentPage, totalPages } } }, onSelectExtension, onNewExtension, viewLoading, themeName } = this.props;
    return (
      <div className="list-view details-section" style={{ top: 190, paddingBottom: 40, width: '90%', overflow: 'auto' }}>
        <InfiniteScroll
          initialLoad={false}
          loadMore={() => this.appendExtensions(currentPage + 1)}
          hasMore={currentPage + 1 < totalPages}
          loader={<ListLoadingView />}
          useWindow={false}
        >
          <div className="r-full-width-phone" style={{ width: '41%' }}>
            {!_.isEmpty(extensionData) ?
              _.map(extensionData, extension =>
                <ExtensionRow
                  themeColor={themeName}
                  key={extension.id}
                  isSelected={selectedExtension && selectedExtension.id === extension.id}
                  extension={extension}
                  onClick={() => onSelectExtension(extension)}
                />)
                : (
                  <div>
                    {!viewLoading ? (
                      <EmptyView
                        title="noExtensions"
                        onNewEntity={canCreateItem ? () => onNewExtension() : null}
                        newEntityTitle="createNewF"
                        subtitle="noExtensionsDescription"
                        iconName="icon-simple-line-icons-user-following"
                      />) : <ListLoadingView />}
                  </div>
                )
              }
          </div>
        </InfiniteScroll>
      </div>
    );
  }
}

export default ExtensionListView; 